export default class PhonenumberControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.input.value = args.value ? args.value : ''
    this.input.type = 'tel'
    this.input.autocapitalize = 'off'
    this.input.autocorrect = 'off'
    this.input.spellcheck = 'false'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let onclick = () => {
      if (this.input.value) {
        let parsedPhonenumber = this.input.value.trim().replace(/ *\([^)]*\) */g, '').replace(/[^+0-9.]/g, '')

        if (parsedPhonenumber) {
          if (parsedPhonenumber.length < 4) {
            alert('Telefoonummers korter dan 4 cijfers zijn zeer waarschijnlijk noodnummers. U kunt geen noodnummers bellen vanuit deze applicatie.')
            return
          }

          location.href = 'tel:' + parsedPhonenumber
        }
      }
    }

    let button = document.createElement('button')
    button.className = 'icon'
    button.innerHTML = '\ue0c5'
    button.onclick = onclick

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)
    div.appendChild(button)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? this.input.value : null
  }

  setValue (value) {
    this.input.value = value
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/PhonenumberControl.js